import React, { useEffect, useState } from "react";
import { NavLink } from 'react-router-dom';
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import axiosInstance from '../axiosConfig';
import '../styles/loader.css';
import Loader from "../components/Loader";

const TestimonialsBox = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);

    const fetchTestimonials = async (page) => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`/testimonials`, { params: { page } });
            if (response.data.success) {
                setTestimonials((prev) => [...prev, ...response.data.data]);
                setHasMore(response.data.has_more);
            }
        } catch (error) {
            console.error("Error fetching testimonials:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTestimonials(currentPage);
    }, [currentPage]);

    const loadMoreTestimonials = () => {
        if (hasMore) {
            setCurrentPage((prev) => prev + 1);
        }
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <section className="testimonial no-top" aria-label="section">
            <div className="container">
                <div className="row">
                    <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 768: 2, 992: 3 }}>
                        <Masonry gutter="24px">
                            {testimonials.map((item, index) => (
                                <div className="testi-box" key={index}>
                                    <div className="testi-cnt">
                                        <p>{item.description}</p>
                                        <div className="testi-user">
                                            <img
                                                className="rounded-circle"
                                                src={item.profile_img_url}
                                                alt={item.name}
                                            />
                                            <span>{item.name}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Masonry>
                    </ResponsiveMasonry>
                </div>
                <div className="text-center">
                    <div className="spacer-single"></div>
                    {hasMore && (
                        <button
                            className="btn-main"
                            onClick={loadMoreTestimonials}
                            disabled={loading}
                        >
                            {loading ? "Loading..." : "Load More Testimonials"}
                        </button>
                    )}
                </div>
            </div>
        </section>
    );
};

export default TestimonialsBox;
